import receiptService from '../../services/receipt'

const state = {
  receipt: []
}

// getters 
const getters = {
 
}

// actions
const actions = {
    async sendReceiptAction(context, payload) {
      await receiptService.sendReceiptToEmailByOrderId(payload); 
    },  
  
}

// mutations
const mutations = {
  
} 

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}